<div class="container-fluid d-flex p-0">
<app-side-bar></app-side-bar>
<main class="main-content">
  <app-breadcrumb></app-breadcrumb>
    <div class="container">
      <app-calendar-view *ngIf="currentStep === 'calendar'"></app-calendar-view>
      <app-type-selection *ngIf="currentStep === 'type'"></app-type-selection>
      <app-category-selection *ngIf="currentStep === 'category'"></app-category-selection>
      <app-therapeutic-selection *ngIf="currentStep === 'therapeutic'"></app-therapeutic-selection>
      <app-results *ngIf="currentStep === 'results'"></app-results>
    </div>
  </main>
  
  <app-drug-modal></app-drug-modal>
  
  <div class="loading-overlay" [class.active]="loading">
    <div class="loading-spinner">
      <i class="fas fa-spinner fa-spin"></i>
      <p>Loading...</p>
    </div>
  </div>
</div>